export const loadTinyMCE = () => {
  return new Promise((resolve, reject) => {
    if (window.tinymce) {
      resolve(window.tinymce);
      return;
    }

    const script = document.createElement('script');
    script.src = '/tinymce/tinymce.min.js';
    script.onload = () => {
      window.tinymce.init({
        base_url: '/tinymce',
        suffix: '.min'
      });
      resolve(window.tinymce);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
};
